module.exports = require('./helpers/bundle-url').getBundleURL('jZQ3u') + "logo.c51670a8.svg";